// The route-details title: a focus target that survives any change to the
// route's provider state, for dialogs whose opener is gone once they succeed.
export const ROUTE_DETAILS_TITLE_ID = 'route-details-title';

// The Burq sub-tab's heading: where focus goes when a route's card or panel is
// gone, after Keep with Odeko or a dispatch lands the GM on the route list.
export const BURQ_TAB_HEADING_ID = 'burq-routes-heading';

// The Issues page's list: where focus goes when a dialog opened from the
// footer closes, since a send clears the selection and the footer with it.
export const ISSUES_LIST_ID = 'issues-list';

// Focuses an element that may appear only after a refetch renders it; gives up
// after `triesLeft` tries, 100 ms apart.
export const focusWhenPresent = (id: string, triesLeft = 20): void => {
  const element = document.getElementById(id);
  if (element) {
    element.focus();
    return;
  }
  if (triesLeft > 0) {
    setTimeout(() => focusWhenPresent(id, triesLeft - 1), 100);
  }
};
